import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import environment from "web/script/modules/environment";
import { gettext } from "web/script/modules/django-i18n";
import React, { RefObject, useEffect, useState } from "react";
import withReduxProvider from "web/react/redux-provider";
import { languageIsEnglish } from "web/script/modules/language";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
import FollowDesignerButton from "web/react/components/follow-designer-button/follow-designer-button";
import Button from "web/react/components/button/button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ReduxStoreState } from "web/redux/store";
import { useSelector as useReduxSelector } from "react-redux";
import { ProfileProps } from "./profile-header";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./profile-header.css";

interface ProfileHeaderWithLogoProps {
    title: string;
    profile: ProfileProps;
    followCTARef?: RefObject<HTMLDivElement>;
    isIos: boolean;
    isShopHeader?: boolean;
}

function extractTitleState(state: ReduxStoreState): string {
    let titleState = state.feedFiltersReducer.title;
    if (titleState !== null) {
        return titleState;
    } else {
        return "";
    }
}

export function ProfileHeaderWithLogo({
    title,
    profile,
    followCTARef,
    isIos,
}: ProfileHeaderWithLogoProps): JSX.Element {
    const [feedTitle, setFeedTitle] = useState(title);
    const feedTitleState = useReduxSelector(extractTitleState);
    const pageSubType = environment.get("pageSubType");

    let useIosDUText =
        isIos &&
        pageSubType.startsWith("designer") &&
        environment.getFeature("mg_du_banner_ios_to_app");

    useEffect(() => {
        if (feedTitleState) {
            setFeedTitle(feedTitleState);
        }
    }, [feedTitleState]);

    const [showBrandAd, setShowBrandAd] = useState<boolean>(false);
    useEffect(() => {
        if (profile.features && profile.features.pmt_brand_ads && profile.brand_ad) {
            setShowBrandAd(true);
            analytics.event("brand_ads", "impression", "perf_brand_ad", true, {
                partner: profile.brand_ad.partner,
            });
        }
    }, [profile.features, profile.brand_ad]);

    return (
        <>
            <div
                className={classnames(styles.wrapper, {
                    [styles.pmt477Design]: showBrandAd,
                })}
            >
                <div className={styles.content}>
                    <div className={styles.brand}>
                        {profile.small_photo_url && (
                            <div className={styles.icon}>
                                <img
                                    src={profile.small_photo_url}
                                    alt={
                                        // "{designer_name} logotype"
                                        gettext("feed.designer_logo.image_alt_text", {
                                            designer_name: title,
                                        })
                                    }
                                />
                            </div>
                        )}
                        {feedTitle && (
                            <h1
                                className={styles.name}
                                dangerouslySetInnerHTML={{
                                    __html: feedTitle,
                                }}
                            />
                        )}
                    </div>
                    <div className={styles.buttonWrapper}>
                        {languageIsEnglish() && profile.follow_button && (
                            <div ref={followCTARef} className={styles.followButtonWrapper}>
                                <FollowDesignerButton
                                    className={styles.followButton}
                                    followedText={profile.follow_button.followed_text}
                                    notFollowedText={
                                        useIosDUText
                                            ? // "Get designer updates in the Lyst App"
                                              gettext(
                                                  "designer_updates.get_updates_in_app.header_cta"
                                              )
                                            : profile.follow_button.notfollowed_text_top
                                    }
                                    analyticsParameters={["du_feed_cta", "click_top_cta", "du_cta"]}
                                    lystId={profile.follow_button.lyst_id}
                                    isAuthenticated={profile.follow_button.is_authenticated}
                                    isFollowing={profile.follow_button.is_following}
                                />
                            </div>
                        )}
                        {languageIsEnglish() && profile.retailer_hub_link && (
                            <Button
                                styleType="secondary"
                                className={styles.promos}
                                href={profile.retailer_hub_link}
                                disabled={false}
                                fullWidth={false}
                                fullHeight={false}
                                openInNewTab={false}
                            >
                                <SVGIcon className={styles.promosIcon} name={"tag"} />
                                {// "Promo’s"
                                gettext("promotion_message.designer.promo_btn_text")}
                            </Button>
                        )}
                    </div>
                </div>
                {profile.brand_ad && showBrandAd && (
                    <div className={styles.brandAdd}>
                        <BrandAdContainer {...profile.brand_ad} />
                    </div>
                )}
                <div className={styles.line} />
            </div>
        </>
    );
}

export default withReduxProvider(ProfileHeaderWithLogo);
